import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import type { Candidate } from "@/components/candidates/types";

interface UpdateCandidateProfileParams {
  candidateId: string;
  data: Partial<Candidate>;
}

export const useUpdateCandidateProfile = () => {
  const queryClient = useQueryClient();

  const updateCandidateProfile = useMutation({
    mutationFn: async ({ candidateId, data }: UpdateCandidateProfileParams) => {
      const { data: result, error } = await supabase
        .from("candidates")
        .update(data)
        .eq("id", candidateId)
        .select()
        .single();

      if (error) {
        console.error("Error updating candidate profile:", error);
        throw error;
      }

      return result;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["candidate", data.id] });
      toast.success("Candidate profile updated successfully");
    },
    onError: (error) => {
      console.error("Failed to update candidate profile:", error);
      toast.error("Failed to update candidate profile");
    },
  });

  return {
    updateCandidateProfile: updateCandidateProfile.mutate,
    isUpdatingProfile: updateCandidateProfile.isPending,
  };
};